<template>
  <div class="mt-3">
    <div class="space-y-4">
      <GameHero :game="game" />
      <GameGoals :game="game" v-if="game.status == 'finished'" />
      <GameTable :game="game" v-if="game.table?.length" />
      <GameStats :game="game" v-if="game.status == 'finished'" />
      <GameEvents :game="game" v-if="game.status == 'finished'" />
    </div>
  </div>
</template>

<script setup>
definePageMeta({
  layout: 'league',
  middleware: ['game-data'],
})

const route = useRoute()
const game = useState(`game:${route.params?.game}`)

// Create league slug from season
const leagueSlug = computed(() => {
  return game.value?.season?.slug
    ?.replace(game.value?.season?.year, '') // Remove the year
    ?.trim() // Trim any spaces (optional)
    ?.replace(/-+$/, '') // Remove any trailing dashes
})

// Show 404 if wrong league or no game is found
if (route.params.league !== leagueSlug.value || (!game.value?.id || !game.value.slug)) {
  throw createError({
    statusCode: 404,
    message: 'not found',
    fatal: true
  })
}
</script>
